import React from "react";
import Select from "react-select";

/******************************************************
 *
 * Composant générique Single Select
 *
 ******************************************************/

export default function SingleSelectField({

    /* Bootstrap */
    name,

    col = "col-12",
    labelCol = 4,
    inputCol = 8,

    /* Label */

    label = "",
    icon = "",

    /* Données */

    options = [],
    value = null,

    optionValue = "id",
    optionLabel = "label",

    /* Placeholder */

    placeholder = "Sélectionner...",

    /* Etat */

    disabled = false,
    required = false,
    isClearable = true,
    isSearchable = true,

    /* Validation */

    error = "",

    /* Callback */

    onChange

}) {

    //----------------------------------------------------
    // Styles React Select
    //----------------------------------------------------

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: "46px",
            borderRadius: "10px",
            borderColor: error
                ? "#dc3545"
                : state.isFocused
                    ? "#198754"
                    : "#ced4da",

            boxShadow: "none",
            transition: ".20s",
            "&:hover": {
                borderColor: "#198754"
            }

        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: "2px 12px"

        }),

        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d"
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "#212529",
            fontWeight: 500
        }),

        indicatorSeparator: () => ({
            display: "none"
        }),

        dropdownIndicator: (provided) => ({
            ...provided,
            color: "#198754"
        }),

        clearIndicator: (provided) => ({
            ...provided,
            color: "#dc3545"
        }),

        option: (provided, state) => ({
            ...provided,
            backgroundColor:
                state.isSelected
                    ? "#198754"
                    : state.isFocused
                        ? "#d1e7dd"
                        : "#ffffff",
            color:
                state.isSelected

                    ? "#ffffff"

                    : "#212529",

            cursor: "pointer"

        }),

        menu: (provided) => ({

            ...provided,

            zIndex: 99999

        }),

        menuPortal: (provided) => ({

            ...provided,

            zIndex: 99999

        })

    };

    //----------------------------------------------------

    return (

        <div className={`${col} mb-3`}>

            <div className="row align-items-center">

                {/* Label */}

                <label
                    className={`col-md-${labelCol} col-form-label fw-semibold`}
                >

                    {

                        icon &&

                        <i className={`${icon} me-2 text-success`}></i>

                    }

                    {label}

                    {

                        required &&

                        <span className="text-danger ms-1">*</span>

                    }

                </label>

                {/* Champ */}

                <div className={`col-md-${inputCol}`}>

                    <Select
                        styles={customStyles}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"

                        options={options}

                        value={
                            options.find(
                                o => String(o[optionValue]) === String(value)
                            ) || null
                        }

                        placeholder={placeholder}

                        isDisabled={disabled}

                        isClearable={isClearable}

                        isSearchable={isSearchable}

                        getOptionValue={(o) => String(o[optionValue])}

                        getOptionLabel={(o) =>
                            typeof optionLabel === "function"
                                ? optionLabel(o)
                                : o[optionLabel]
                        }

                        onChange={(selectedOption) => {

                            onChange({
                                target: {
                                    name,
                                    value: selectedOption
                                        ? selectedOption[optionValue]
                                        : ""
                                }
                            });

                        }}
                    />

                    {

                        error &&

                        <div className="invalid-feedback d-block">

                            {error}

                        </div>

                    }

                </div>

            </div>

        </div>

    );

}